export const FETCH_FAQ_BY_SEARCH = 'FETCH_FAQ_BY_SEARCH'
export const FETCH_FAQ_BY_SEARCH_FULFILLED = 'FETCH_FAQ_BY_SEARCH_FULFILLED'
export const FETCH_FAQ_BY_SEARCH_REJECTED = 'FETCH_FAQ_BY_SEARCH_REJECTED'

export const FETCH_POPULAR_FAQS = 'FETCH_POPULAR_FAQS'
export const FETCH_POPULAR_FAQS_FULFILLED = 'FETCH_POPULAR_FAQS_FULFILLED'
export const FETCH_POPULAR_FAQS_REJECTED = 'FETCH_POPULAR_FAQS_REJECTED'

export const FETCH_FAQ_CONTENT = 'FETCH_FAQ_CONTENT'
export const FETCH_FAQ_CONTENT_FULFILLED = 'FETCH_FAQ_CONTENT_FULFILLED'
export const FETCH_FAQ_CONTENT_REJECTED = 'FETCH_FAQ_CONTENT_REJECTED'

export const FETCH_SIDEBAR_NAV = 'FETCH_SIDEBAR_NAV'
export const FETCH_SIDEBAR_NAV_FULFILLED = 'FETCH_SIDEBAR_NAV_FULFILLED'
export const FETCH_SIDEBAR_NAV_REJECTED = 'FETCH_SIDEBAR_NAV_REJECTED'

export const FETCH_ALERT_CONTENT = 'FETCH_ALERT_CONTENT'
export const FETCH_ALERT_CONTENT_FULFILLED = 'FETCH_ALERT_CONTENT_FULFILLED'
export const FETCH_ALERT_CONTENT_REJECTED = 'FETCH_ALERT_CONTENT_REJECTED'

export const FETCH_PAGE_CONTENT = 'FETCH_PAGE_CONTENT'
export const FETCH_PAGE_CONTENT_FULFILLED = 'FETCH_PAGE_CONTENT_FULFILLED'
export const FETCH_PAGE_CONTENT_REJECTED = 'FETCH_PAGE_CONTENT_REJECTED'

export const FETCH_PAGE_PROMO_CONTENT = 'FETCH_PAGE_PROMO_CONTENT'
export const FETCH_PAGE_PROMO_CONTENT_FULFILLED = 'FETCH_PAGE_PROMO_CONTENT_FULFILLED'
export const FETCH_PAGE_PROMO_CONTENT_REJECTED = 'FETCH_PAGE_PROMO_CONTENT_REJECTED'

export const SAVE_LIVE_CHAT_STATUS = 'SAVE_LIVE_CHAT_STATUS'
export const SET_CHAT_MINIMIZED = 'SET_CHAT_MINIMIZED'
export const SET_CHAT_ENDED = 'SET_CHAT_ENDED'
export const TOGGLE_CHAT = 'TOGGLE_CHAT'
